<footer class="footer-area">
    <div class="container-fluid">
        <!-- <div class="footer-contact">
            <div class="newsleter-area">
                <h2>Subscribe Our Newsletter</h2>
                
                <form class="newsletter-form">
                    <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL">
                    <button class="subscribe-btn" type="submit">Subscribe</button>
                </form>
            </div>
        </div> -->

        <div class="pt-4">
            <div class="row" style="border-bottom: 1px solid #000;">
                <div class="col-lg-4 col-md-4">
                    <div class="footer-list d-flex">
                        <a routerLink="/"><img src="assets/img/logo.png" width="164" alt="Logo"></a>

                        <ul>
                            <li><a routerLink="/terms-condition">Terms</a></li>
                            <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                            <li><a routerLink="/order-apps">Order Apps</a></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4">
                    <div class="footer-list2">
                        <div class="text-center mb-4">
                            <i style="color: #000;" class="bx bxs-stopwatch"></i>
                        </div>
                        <div class="m-auto">
                            <p>"{{working_hours || ''}}"</p>
                            <!-- Drop by anytime between 9 AM and 11 PM — we’re here to serve you! -->
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-4">
                    <div class="footer-side-list">
                        <ul>
                            <li><i class='bx bxs-phone'></i> <a href="tel:{{phone}}">{{phone}}</a></li>
                            <li><i class='bx bxs-envelope'></i> <a href="mailto:{{email}}">{{email}}</a></li>
                            <li><i class='bx bxs-map'></i> <a href="https://maps.app.goo.gl/6xRRnn1AUrBJtjvf7" target="_blank">{{address}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="bottom-text d-block">
                        <p class="pb-0">© 2025 BAYONNE BBQ . All rights reserved</p>
                        <p class="pt-1">Website Designed & Developed By <a href="http://onepice.org/" target="_blank">ONE PICE DIGITAL SOLUTIONS</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>